import React, { Component } from "react"
import ValidationDatePicker from '../ValidationDatePicker'
import moment from "moment"

class AnswerDate extends Component {

  constructor(props) {
    super(props)
    if (props.questionnaire && props.questionnaire[props.name]) {

      this.state = {
        data: props.questionnaire[props.name].value,
        formValid: true
      };
      this.props.checkFormValid(this.props.name, true)
    } else {
      this.state = {
        data: null,
        formValid: false
      };
      this.props.checkFormValid(this.props.name, false)
    }
  }
  handleOnInputChange = (err, event) => {
    let value = event.target.value
    this.setState(
      (prev, props) => {
        prev.formValid = !err.hasError;
        props.checkFormValid(props.name, prev.formValid)
        return {data: value, formValid: prev.formValid}
      },
      () => this.props.onChange(this.props.name, {value: this.state.data})
    )
  }
  handleOnDateChange = (date, errorPayload) => {
    this.setState((prev) => {
      let data = {date, name: this.props.name}
      prev.formValid = !errorPayload.hasError;
      prev.data = data.date
      this.props.checkFormValid(this.props.name, prev.formValid)
      this.props.onChange(this.props.name, {value: data.date.format("DD-MMM-YYYY")})
      return {data: prev.data, formValid: prev.formValid}
    })
  }
  handleOnError = (event, errorPayload) => {
    let err = errorPayload;
    this.setState((prev, props) => {
      prev.formValid = !err.hasError;
      this.props.checkFormValid(props.name, prev.formValid)
      return { formValid: prev.formValid };
    });
  }
  render( ) {
    const {label, name, placeholder, simple} = this.props
    return (
      <div>
        <div className={!simple ? "aps-questionnaire-answers uk-grid":"aps-questionnaire-answers aps-questionnaire-ans-box-padding-bottom uk-grid"} data-uk-grid>
          <div className="uk-width-expand aps-questionnaire-answers-first-col uk-first-column">
            <div className={!simple ? "aps-questionnaire-answers-title uk-text-bold":"aps-questionnaire-answers-box-title"}>
            {label}
            </div>
          </div>
          <div className="uk-width-1-2 aps-questionnaire-answers-second-col uk-text-right">
            <ValidationDatePicker
              name={name}
              onChange={(errorPayload, date) => this.handleOnDateChange(date, errorPayload)}
              dateFormat="DD-MMM-YYYY"
              placeholderText={placeholder}
              locale="fr"
              showYearDropdown
              scrollableYearDropdown
              selected={this.state.data ? moment(this.state.data, "DD-MMM-YYYY") : null}
              onBlur={(errorPayload, event) =>
                this.handleOnError(event, errorPayload)
              }
            />
          </div>
        </div>
      </div>
    )
  }
}
export default AnswerDate



// WEBPACK FOOTER //
// ./src/components/Questionnaire/AnswerDate.js